export default "__VITE_ASSET__Cr8mO3us__";